import { useEffect, useState } from "react";

// Delays reacting to fast-changing input (typically search text) so filtering/
// sorting of a large table doesn't recompute on every keystroke.
export default function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
